import { hasPermission } from "../modules/rbac/permission-manifest";

const associateSettings = (associate) => {
  return [
    // {
    //   title: "Email Settings",
    //   icon: "email",
    //   path: "EmailSettings",
    //   visible: hasPermission("canReadEmailSetting", null, associate),
    // },
    {
      title: "Associates",
      icon: "person",
      path: "Associates",
      visible: hasPermission("canReadAssociate", null, associate),
    },
    {
      title: "Roles & Permissions",
      icon: "lock",
      path: "Roles",
      visible: hasPermission("canReadRole", null, associate),
    },
    {
      title: "Logout",
      icon: "exit_to_app",
      path: "AssociateLogin",
      children: [],
      visible: true,
    },
  ];
};

const userSettings = (user) => {
  return [
    {
      title: "Logout",
      icon: "exit_to_app",
      path: "UserLogin",
      children: [],
      visible: true,
    },
  ];
};

export { associateSettings, userSettings };
